"use strict";

exports.__esModule = true;
exports.default = getLocale;
// composes local to be used for the Intl js library
function getLocale(country, language) {
  return `${language.toLowerCase()}-${country.toUpperCase()}`;
}
module.exports = exports.default;